module.exports = __webpack_public_path__ + "static/media/img_10.00452f3d.png";